export enum InviteUserActionsType {
  INVITE_USER = '[Invite User] Invite user',
  USER_INVITED = '[User Invited] User invited',
  INVITE_USER_ERROR = '[Invite User] Invite user error'
}
